import { useEffect, useState } from "react";
import { ShouldRevalidateFunctionArgs, useFetcher, useLoaderData } from "react-router-dom";
import { arraysAreEqual, packObjForSubmit, unpackObjForSubmit } from "../../utils";
import { doFetch } from "../../utils/doFetch";
import { doFetchPut } from "../../utils/doFetchPut";
import { DOA } from "./DOA";
import { IDOAData, IDOAShift } from "./DOAData";

export const DOARouteLoader = async ({ request }: { request: any, params: any }) => {
  return doFetch('doa', { signal: request.signal }, true, false);
};

export const DOARouteAction = async ({ request }: { request: any, params: any }) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut(
    'doa',
    { signal: request.signal },
    obj
  );
}

export const DOARouteShouldRevalidate = ({ actionResult }: ShouldRevalidateFunctionArgs) => !actionResult?.error

export const DOARoute = () => {
  const fetcher = useFetcher();
  const loaderData = useLoaderData();
  const data = fetcher.data?.shifts ? fetcher.data as IDOAData : loaderData as IDOAData;
  const [shifts, setShifts] = useState<IDOAShift[]>(data.shifts);
  const [openAlert, setOpenAlert] = useState(false);
  const [showLastDeclared, setShowLastDeclared] = useState(false);
  const onShowLastDeclared = () => setShowLastDeclared(prev => !prev);

  useEffect(() => {
    if (fetcher.data?.error) {
      setOpenAlert(true);
    }
  }, [fetcher.data?.error])

  const onSelectShift = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    setShifts(prev => prev.map(s => s.despatchDescription === value ? { ...s, declared: checked } : s));
  };

  const onRefresh = () => {
    fetcher.load('/doa');
    setShowLastDeclared(false);
  }

  const onSubmit = async () => {
    const formData = packObjForSubmit({ shifts });

    await fetcher.submit(formData, {
      method: "put",
      action: '/doa'
    });
  }

  const onCloseAlert = () => {
    setOpenAlert(false);
    fetcher.load('/doa');
  }

  return (
    <DOA
      openAlert={openAlert}
      onCloseAlert={onCloseAlert}
      data={data}
      shifts={shifts}
      hasChanges={data.shifts && !arraysAreEqual(data.shifts, shifts)}
      onRefresh={onRefresh}
      onSelectShift={onSelectShift}
      onSubmit={onSubmit}
      showLastDeclared={showLastDeclared}
      onShowLastDeclared={onShowLastDeclared}
    />
  );
}
